import React from 'react';
import { Link } from 'react-router-dom';

export const LandingFooter: React.FC = () => {
  return (
    <footer className="border-t border-base-300">
      <div className="max-w-[1248px] mx-auto py-6 md:py-8 px-5 md:px-6 flex flex-wrap items-center gap-4 md:gap-6 text-xs md:text-[13px] text-base-content/60">
        <span className="hidden sm:flex items-center gap-2">
          <img
            src="/icon.svg"
            alt="FretBoard"
            className="size-6 rounded-md object-cover"
          />
          <span dir="ltr" className="font-bold text-base-content">
            FretBoard
          </span>
        </span>
        <span>© ۱۴۰۵ فرت‌بورد</span>
        <div className="flex-1" />
        <a href="#" className="inline-flex items-center justify-center min-h-11 min-w-11 hover:text-base-content transition-colors">
          نصب نسخهٔ وب
        </a>
        <a href="#" className="inline-flex items-center justify-center min-h-11 min-w-11 hover:text-base-content transition-colors">
          <span className="hidden sm:inline">دانلود </span>اندروید
        </a>
        <Link to="/auth?mode=login" className="hidden sm:inline-flex items-center min-h-11 hover:text-base-content transition-colors">
          ورود
        </Link>
      </div>
    </footer>
  );
};
